import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../../render/table/table-cell"
import FieldAttachmentsTotal_TableCellCalculated_Hovered from "./hovered"
import FieldAttachmentsTotal_TableCellCalculated_NotHovered from "./not-hovered"

// const debug = "FieldAttachmentsTotal_TableCellCalculated"
const debug = false

export default function FieldAttachmentsTotal_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)

    const onMouseEnter = () => {
        if (!props.column.usesSumAggregation) {
            return
        }

        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldAttachmentsTotal_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    } else {
        return (
            <FieldAttachmentsTotal_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
